import { FC } from 'react'
import { theme } from '../../../styles/theme'
import { texts } from '../../locale'

import imgUrl1 from './../assets/01.webp'
import imgUrl2 from './../assets/02.webp'
import imgUrl3 from './../assets/03.webp'
import imgUrl4 from './../assets/04.webp'

import { Answer, Bubble } from './styled'

type Props = {
  direction: string
  woman: number
}

const AnswerContainer: FC<Props> = ({ direction, woman }) => {
  const images = [
    imgUrl1,
    imgUrl2,
    imgUrl3,
    imgUrl4,
    imgUrl2,
    imgUrl1,
    imgUrl4,
    imgUrl3,
  ]
  const answers = [
    texts.answers_3,
    texts.answers_5,
    texts.answers_7,
    texts.answers_9,
    texts.answers_12,
    texts.answers_14,
    texts.answers_16,
    texts.answers_18,
  ]
  const names = [
    texts.answers_2,
    texts.answers_4,
    texts.answers_6,
    texts.answers_8,
    texts.answers_11,
    texts.answers_13,
    texts.answers_15,
    texts.answers_17,
  ]
  return (
    <Answer $dir={direction}>
      <h3>{woman < 5 ? texts.answers_1 : texts.answers_10}</h3>
      <div>
        <Bubble $dir={direction}>
          {answers[woman - 1]}
          <span>{names[woman - 1]}</span>
          {direction === 'left' ? (
            <>
              <svg viewBox="0 0 120 78" className="horizontal">
                <path
                  fill={theme.colors.background}
                  stroke={theme.colors.text}
                  strokeWidth="1px"
                  vectorEffect="non-scaling-stroke"
                  d="M120 0, 0 39, 120 78"
                />
              </svg>
              <svg viewBox="0 0 78 120" className="vertical">
                <path
                  fill={'white'}
                  stroke={theme.colors.text}
                  strokeWidth="1px"
                  vectorEffect="non-scaling-stroke"
                  d="M0 0, 10 120, 78 0"
                />
              </svg>
            </>
          ) : (
            <>
              <svg viewBox="0 0 120 78" className="horizontal">
                <path
                  fill={theme.colors.background}
                  stroke={theme.colors.text}
                  strokeWidth="1px"
                  vectorEffect="non-scaling-stroke"
                  d="M0 0, 120 39, 0 78"
                />
              </svg>
              <svg viewBox="0 0 78 120" className="vertical">
                <path
                  fill={'white'}
                  stroke={theme.colors.text}
                  strokeWidth="1px"
                  vectorEffect="non-scaling-stroke"
                  d="M0 0, 10 120, 78 0"
                />
              </svg>
            </>
          )}
        </Bubble>
        <img src={images[woman - 1]}></img>
      </div>
    </Answer>
  )
}
export default AnswerContainer
